/**
 * تنسيق موحَّد — الأرقام لاتينية في كل المنصة (قرار مثبَّت: لا خلط داخل صفحة واحدة).
 * والأشهرُ بأسمائها المعتادة (سبتمبر لا أيلول — طلب صاحب المنصة 23 سبتمبر) بلغةٍ عربية عامة `ar`.
 * والتوقيتُ توقيتُ عمّان أينما فُتحت الصفحة (23 سبتمبر 2026): المواعيدُ والأقفالُ تُحسب في الخادم بعمّان،
 * فعرضُها بمنطقة الجهاز يُظهر لمسؤولٍ مسافرٍ موعداً غيرَ الموعد.
 */
const TZ = 'Asia/Amman';
const dateFmt = new Intl.DateTimeFormat('ar-u-nu-latn-ca-gregory', { year: 'numeric', month: 'long', day: 'numeric', timeZone: TZ });
const dateShortFmt = new Intl.DateTimeFormat('ar-u-nu-latn-ca-gregory', { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: TZ });
const dateTimeFmt = new Intl.DateTimeFormat('ar-u-nu-latn-ca-gregory', {
  year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false, timeZone: TZ,
});

export function fmtDate(v: string | Date | null | undefined): string {
  if (!v) return '—';
  const d = typeof v === 'string' ? new Date(v) : v;
  return Number.isNaN(d.getTime()) ? '—' : dateFmt.format(d);
}
export function fmtDateShort(v: string | Date | null | undefined): string {
  if (!v) return '—';
  const d = typeof v === 'string' ? new Date(v) : v;
  return Number.isNaN(d.getTime()) ? '—' : dateShortFmt.format(d);
}
export function fmtDateTime(v: string | Date | null | undefined): string {
  if (!v) return '—';
  const d = typeof v === 'string' ? new Date(v) : v;
  return Number.isNaN(d.getTime()) ? '—' : dateTimeFmt.format(d);
}
export function fmtNumber(n: number | null | undefined): string {
  return n == null ? '—' : new Intl.NumberFormat('en-US').format(n);
}
/** العمر بالسنوات — يُعرض بجانب تاريخ الميلاد في ملف الطالب */
export function ageYears(dob: string | Date | null | undefined): number | null {
  if (!dob) return null;
  const d = typeof dob === 'string' ? new Date(dob) : dob;
  if (Number.isNaN(d.getTime())) return null;
  const now = new Date();
  let a = now.getUTCFullYear() - d.getUTCFullYear();
  const m = now.getUTCMonth() - d.getUTCMonth();
  if (m < 0 || (m === 0 && now.getUTCDate() < d.getUTCDate())) a -= 1;
  return a;
}
/** أحرف الاسم للصورة الرمزية */
export function initials(fullName: string): string {
  const parts = fullName.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '؟';
  if (parts.length === 1) return parts[0].slice(0, 2);
  return parts[0][0] + parts[parts.length - 1][0];
}
/** السنة الدراسية الحالية بصيغة 2026-2027 — يقترحها معالج ترقية الصف */
export function currentAcademicYear(): string {
  const now = new Date();
  const start = now.getMonth() >= 7 ? now.getFullYear() : now.getFullYear() - 1;
  return `${start}-${start + 1}`;
}

const dateTimeSecFmt = new Intl.DateTimeFormat('ar-u-nu-latn-ca-gregory', {
  year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false, timeZone: TZ,
});
/** بالثواني — لتفاصيل حدثٍ في التدقيق، حيث يتتابع حدثان في الدقيقة نفسِها */
export function fmtDateTimeSec(v: string | Date | null | undefined): string {
  if (!v) return '—';
  const d = typeof v === 'string' ? new Date(v) : v;
  return Number.isNaN(d.getTime()) ? '—' : dateTimeSecFmt.format(d);
}
const dayKeyFmt = new Intl.DateTimeFormat('en-CA', { timeZone: TZ });
/** اليومُ `YYYY-MM-DD` بتوقيت عمّان، مُزاحاً بعدد أيام (سالبٌ للماضي) — لاختصارات المدد */
export function ammanDayKey(offsetDays = 0, at: Date = new Date()): string {
  return dayKeyFmt.format(new Date(at.getTime() + offsetDays * 86_400_000));
}

/** حجمُ ملفٍّ بوحدةٍ مقروءة — بايت/ك.ب/م.ب (كان محلياً في لوحة المرفقات؛ صار مشتركاً مع مجموعات الكادر 0114) */
export function fmtBytes(n: number): string {
  if (n < 1024) return `${n} بايت`;
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} ك.ب`;
  return `${Math.round((n / (1024 * 1024)) * 10) / 10} م.ب`;
}
